import './BaseLayout.scss'
import Header from "../../modules/header/Header";
import Main from "../../modules/main/Main";
import Footer from "../../modules/footer/Footer";

const BaseLayout = () => {
  return (
    <>
      <Header/>
      <Main/>
      <Footer/>
    </>
  )
}

export default BaseLayout;